import apiClient from './axios'

/**
 * Get all audit logs with optional filters
 */
export const getAuditLogs = async (params = {}) => {
  const { data } = await apiClient.get('/v1/audit-logs', { params })
  return data
}

/**
 * Get a single audit log by ID
 */
export const getAuditLog = async (id) => {
  const { data } = await apiClient.get(`/v1/audit-logs/${id}`)
  return data
}
